<template lang="pug">
div
  section.u-mt-md
    AppTitle(:title="$t('mantra')")
    .grid.is-widescreen-8.is-desktop-10
      .column
        p.u-text-lg {{$t('mantraDesc')}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec1')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
            h4 {{item.title}}
            p {{item.desc}}
  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Baianat devops",
    "pageDesc":"Engineer your solutions for performance, manage your servers, and stay on top of your system metrics with automation.",
    "mantra":"Accelerate your process |with DevOps.",
    "mantraDesc":"Reduce the time needed for shipping products. Increase your team efficiency and reduce the costs resulting from many iterations through a more innovative DevOps approach.",
    "sec1":"Continuity and automation solutions.",
    "sec1Items":{
      "1":{
        "title":"Managed AWS servers",
        "desc":"Starting from a tailored plan around your needs, we will take care of your applications; managing, securing and monitoring them along the road while providing you with detailed analysis and feedback."
      },
      "2":{
        "title":"Managed linux servers",
        "desc":"Have your servers setup with proper software management and technical support. We will take care of your Linux environment and maintain your dedicated servers as well as ensure their security."
      },
      "3":{
        "title":"Continuous integration and deployment",
        "desc":"Save time and enjoy faster deliveries by having customizable CI/CD automation processes resulting in a steady release pipeline with continuous tests and deployments."
      },
      "4":{
        "title":"Continuous monitoring and feedback",
        "desc":"Make sure your systems are acting as intended and are providing the expected results. Keep track of key areas in your software and detect issues early."
      }
    },
    "sec2":"The ultimate collaboration |towards success.",
    "sec2Items":{
      "1":{
        "title":"DevSecOps",
        "desc":"Development Security Operations come to provide you with automated security tests in order to minimize vulnerabilities in your systems from the moment they are built."
      },
      "2":{
        "title":"DevOps training",
        "desc":"Attain multidisciplinary knowledge about development, infrastructure and server administration to build a solid DevOps skill set and help organizations achieve their goals."
      },
      "3":{
        "title":"Insights and consultation",
        "desc":"Our DevOps team will answer your questions, as well as give you a full review of your infrastructure with proper advice on how to build well-rounded systems."
      }
    },
    "cta":"Excel your development <br> process now"
  },
  "ar": {
    "pageTitle":"ديف أوبس",
    "pageDesc":"نساعدك على تأمين وحماية أعمالك ونضمن سيطرتك التامة عليها ومتابعتك لها من خلال قدرات أوتوماتيكية منتظمة.",
    "mantra":"استغل قوى الديف |أوبس لحماية وأمان |برمجياتك.",
    "mantraDesc":"نساعدك على تقليل الوقت اللازم لشحن المنتجات، وكذلك زيادة كفاءة أداء فريقك وتقليل التكاليف الناتجة عن العديد من المراجعات من خلال الديف أوبس الأكثر ابتكارًا وآمانًا.",
    "sec1":"حلول مستمرة وآلية.",
    "sec1Items":{
      "1":{
        "title":"إدارة سيرفرات أمازون (AWS)",
        "desc":"نساعدك على اختيار خطة مناسبة لك ونهتم بتطبيقاتك من حيث إدارتها وتأمينها ورصدها، وكذلك تزويدك بالتحليلات المفصلة وردود الأفعال."
      },
      "2":{
        "title":"ادارة سيرفرات لينكس",
        "desc":"تمتع بإعداد السيرفرات لديك من خلال إدارة البرامج والدعم الفني المناسبين. سنهتم ببيئة لينكس ونحافظ على السيرفرات الخاصة بك بالإضافة إلى ضمان أمنها وحمايتها."
      },
      "3":{
        "title":"التكامل المستمر والنشر",
        "desc":"وفر الوقت واستمتع بالتسليم الأسرع عن طريق إجراء عمليات CI / CD آلية قابلة للتخصيص، مما يؤدي إلى إنشاء خطوط ثابتة مع اختبارات وعمليات نشر مستمرة."
      },
      "4":{
        "title":"المراقبة المستمرة وردود الأفعال",
        "desc":"تأكد أن أجهزتك تعمل على النحو المطلوب وتُقدم النتائج المتوقعة منها. تتبع المجالات الرئيسية في برنامجك واكتشف المشكلات في وقت مبكر."
      }
    },
    "sec2":"التعاون التام |نحو النجاح.",
    "sec2Items":{
      "1":{
        "title":"عمليات تطوير الأمان والحماية",
        "desc":"نوفر لك عمليات أمان متطورة من خلال اختبارات أمان تلقائية؛ لتقليل نقاط الضعف في أنظمتك منذ اللحظة التي يتم إنشاؤها فيها."
      },
      "2":{
        "title":"تدريب ديف أوبس",
        "desc":"احصل على معرفة متعددة التخصصات حول البرمجة والبنية التحتية وإدارة السيرفرات لبناء مجموعة من المهارات القوية ومساعدة المؤسسات على تحقيق أهدافها."
      },
      "3":{
        "title":"الرؤى والاستشارات",
        "desc":"سيجيب فريق ديف أوبس عن أسئلتك، كما سيقدم لك مراجعة كاملة للبنية التحتية الخاصة بك مع نصيحة مناسبة حول كيفية بناء أنظمة متزنة."
      }
    },
    "cta":"أمن عملك على <br> الانترنت."
  }
}
</i18n>
